module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qes64i/tc-custom/9781605507057.jpg?1730492329553",
      "alt": "This image is the cover for the book Everything Ghost Hunting Book, The Everything Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Everything Ghost Hunting Book, The Everything Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Shadowpeople .")]), _vm._v(".. cold spots ... orbs. Ghosthunter Melissa Martin Ellis takes readers on an exciting high-tech journey into the supernatural world of haunted sites, restless souls, and messages from beyond the grave. Readers explore motion sensors, highly sensitive digital cameras, and so-called Ghost Telephones, as well as the supernatural phenomena themselves, including:PoltergeistsElectronic-voice phenomena (EVP)PossessionPhoto anomaliesSéances and voodoo rituals Appealing to the same audience as such popular TV shows as "), _c('i', [_vm._v("Lost")]), _vm._v(", "), _c('i', [_vm._v("Medium")]), _vm._v(", "), _c('i', [_vm._v("Invasion")]), _vm._v(", "), _c('i', [_vm._v("Charmed")]), _vm._v(", "), _c('i', [_vm._v("Ghost Hunters")]), _vm._v(", "), _c('i', [_vm._v("Destination Truth")]), _vm._v(", and "), _c('i', [_vm._v("Most Haunted")]), _vm._v(", this book shows readers how today's investigators use the tools of modern science to study a wide range of paranormal activity.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Melissa Martin Ellis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An Adams Media author.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0